<template>
  <div
    id="mainbox"
    style="
      padding: 34px;
      background-color: #f1f4fa;
      height: calc(100vh - 51px);
      box-sizing: border-box;
      overflow: scroll;
    "
  >
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      "
    >
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin-bottom: 39px"
      >
        <el-breadcrumb-item
          v-for="(item, key) in breadcrumb"
          :key="key"
          :to="{ name: item.path }"
        >
          {{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      style="
        background-color: #fff;
        overflow: hidden;
        padding: 0 36px;
        text-align: left;
      "
    >
      <div style="text-align: left; margin: 18px 0">查询</div>
      <div
        class="formBox"
        style="
          background: #ffffff;
          border: 2px solid #dcdfe6;
          display: inline-block;
        "
      >
        <el-form
          :inline="true"
          style="text-align: left"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="用户ID">
            <el-input
              style="width: 200px"
              v-model="formInline.user_id"
              placeholder="请输入用户ID"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                getList();
              "
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="user_id" label="用户 ID"> </el-table-column>
          <el-table-column prop="brand_id" label="品牌 ID"> </el-table-column>
          <el-table-column prop="brand_name" label="品牌名称">
          </el-table-column>
          <el-table-column prop="agent_id" label="代理 ID"> </el-table-column>
          <el-table-column prop="agent_name" label="代理名称">
          </el-table-column>
          <el-table-column prop="has_permission" label="是否有权限">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.has_permission"
                :active-value="true"
                :inactive-value="false"
                @change="togglePermission(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin: 20px 0"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataPermissionList",
  data() {
    return {
      breadcrumb: [{ name: "数据权限列表" }],
      tableData: [],
      formInline: { user_id: "" },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      savedUserId: "", // 保存查询到的用户ID
    };
  },
  methods: {
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get("/api/datap/list", {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
            user_id: this.formInline.user_id,
          },
        })
        .then((response) => {
          loading.close();
          this.tableData = response.data.items;
          this.total = response.data.total;
          // 保存查询到的用户ID
          this.savedUserId = parseInt(this.formInline.user_id, 10);
          //console.log('Saved User ID:', this.savedUserId); // 调试信息
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          loading.close();
        });
    },
    reset() {
      this.currentPage = 1;
      this.formInline = { user_id: "" };
      //this.savedUserId = '';
      this.getList();
    },
    togglePermission(row) {
      //console.log('Toggling permission for User ID:', this.savedUserId); // 调试信息
      //console.log('Brand ID:', row.brand_id); // 调试信息
      //console.log('Agent ID:', row.agent_id); // 调试信息

      const url = row.has_permission
        ? "/api/datap/create"
        : "/api/datap/delete";
      const method = row.has_permission ? "post" : "delete";
      const requestData = row.has_permission
        ? {
            permissions: [
              {
                agentId: row.agent_id,
                agentName: row.agent_name,
                brandId: row.brand_id,
                brandName: row.brand_name,
                createdAt: new Date().toISOString(),
                userId: row.user_id,
                userNickname: "",
              },
            ],
          }
        : {
            user_id: row.user_id,
            brand_id: row.brand_id,
            agent_id: row.agent_id,
          };
      console.log("Request Data:", requestData); // 调试信息
      this.$axios({
        method: method,
        url: url,
        data: requestData,
      })
        .then(() => {
          this.$message.success("操作成功");
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
        });
    },
  },
  created() {
    // 检查路由中的 user_id 参数
    const userId = this.$route.query.user_id;
    console.log("Created hook executed.");
    if (userId) {
      this.formInline.user_id = userId; // 将路由中的 user_id 赋值到查询输入框
      console.log("User ID from route:", userId);
      this.getList(); // 获取数据
    }
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
body {
  margin: 0;
}
</style>
